/**
 * Importance → visual tone mapping (F7).
 *
 * Maps each importance value to a semantic *tone*, and each tone to design-token
 * Tailwind classes. No hardcoded colours — every class resolves to a token in
 * web/src/design-tokens/global.ts (semantic.* / ink.*). The class strings are
 * full literals so Tailwind's content scanner keeps them. Mirrors F6-6's
 * verdictVisual so the two AI result views read consistently.
 *
 * Tone assignment (docs/data-dictionary.md 变更重要度):
 *   substantive → danger  (业务要点，最需关注)
 *   unclear     → warning (低置信，待人工复核)
 *   wording     → neutral (措辞级，业务含义不变)
 */
import type { ImportanceLevel } from '../../lib/veridoc-api';

export type Tone = 'danger' | 'warning' | 'neutral';

interface ToneClasses {
  /** Solid-ish badge (importance status). */
  badge: string;
  /** Small inline pill (distribution chips). */
  pill: string;
  /** Status dot. */
  dot: string;
}

export const TONE_CLASSES: Record<Tone, ToneClasses> = {
  danger: {
    badge: 'bg-semantic-dangerBg text-semantic-danger border-semantic-danger',
    pill: 'bg-semantic-dangerBg text-semantic-danger',
    dot: 'bg-semantic-danger',
  },
  warning: {
    badge: 'bg-semantic-warningBg text-semantic-warning border-semantic-warning',
    pill: 'bg-semantic-warningBg text-semantic-warning',
    dot: 'bg-semantic-warning',
  },
  neutral: {
    badge: 'bg-ink-100 text-ink-500 border-ink-300',
    pill: 'bg-ink-100 text-ink-500',
    dot: 'bg-ink-400',
  },
};

export const IMPORTANCE_TONE: Record<ImportanceLevel, Tone> = {
  substantive: 'danger',
  unclear: 'warning',
  wording: 'neutral',
};
